module.exports = __webpack_public_path__ + "img/arrow-lifetime-blue.4ef3d2c3.svg";